<template>
    <product-overview
        id="product-overview-page"
        endpoint="/product/overview/"
        page-id="productoverview" />
</template>
<script>
import ProductOverview from '../components/ProductOverview';
export default {
    components: { ProductOverview },
};
</script>
